import PropTypes from 'prop-types';
import React from 'react';
import BaseWidget from '../BaseWidget';
import CventFooter from './Footer';
import CustomFooter from './CustomFooter';
import { resolveTestId } from '@cvent/nucleus-test-automation';

/**
 * Data wrapper for the event footer widget.
 */
export default class FooterWidget extends BaseWidget {
  static displayName = 'FooterWidget';
  static propTypes = {
    /* Application specific classes for the footer */
    classes: PropTypes.object,
    /* Available style keys */
    style: PropTypes.shape({
      footerContainer: PropTypes.object,
      list: PropTypes.object,
      link: PropTypes.object,
      marketingLinks: PropTypes.object,
      policyLinks: PropTypes.object
    }),
    /* translate text resolver for text */
    translate: PropTypes.func,
    // Non-configurable props that should be passed in by the application specific wrapper.
    /* whether to display the cvent logo or not */
    showCventLogo: PropTypes.bool,
    /* whether to display copyright information */
    showCopyrightInformation: PropTypes.bool,
    /* whether to display Event Management Software link */
    showEventManagementSoftware: PropTypes.bool,
    /* whether to display Mobile Event Apps link */
    showMobileEventApps: PropTypes.bool,
    /* whether to display Inquisium link */
    showInquisium: PropTypes.bool,
    /* whether to display Event Venues link */
    showEventVenues: PropTypes.bool,
    /* whether to display Strategic Meetings Management link */
    showStrategicMeetingsManagement: PropTypes.bool,
    /* whether to display privacy policy link */
    showPrivacyPolicy: PropTypes.bool,
    /* whether the links are clickable */
    enableHyperlink: PropTypes.bool,
    /* account settings to show or hide custom footer*/
    allowCustomFooter: PropTypes.bool,
    /* display extra policy links */
    additionalPolicyLinks: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired
    })),
    /* custom privacy policy URL */
    privacyPolicyUrl: PropTypes.string,
    /* to show CCPA Opt Out URL */
    showComplianceText: PropTypes.bool,
    /* compliance text to be shown for compliance link */
    complianceText: PropTypes.string,
    /* callback for click on CCPA Opt Out URL */
    onComplianceClick: PropTypes.func
  };
  static defaultProps = {
    showCventLogo: true,
    showCopyrightInformation: true,
    showEventManagementSoftware: true,
    showMobileEventApps: true,
    showInquisium: true,
    showEventVenues: true,
    showStrategicMeetingsManagement: true,
    showPrivacyPolicy: true,
    enableHyperlink: true,
    showTermsOfUse: false,
    allowCustomFooter: false,
    privacyPolicyUrl: 'https://www.cvent.com/en/privacy-policy.shtml'
  };
  getStyleObject() {
    const links = this.getElementInlineStyle('links');
    return {
      ...super.getStyleObject(),
      link: links,
      copyright: this.getElementInlineStyle('copyright'),
      list: {
        borderColor: links.color
      }
    };
  }

  render() {
    if (this.props.allowCustomFooter) {
      return (
        <CustomFooter
          {...resolveTestId(this.props)}
          {...this.props}
          style={this.getStyleObject()} />
      );
    }
    return (
      <CventFooter
        {...resolveTestId(this.props)}
        {...this.props}
        style={this.getStyleObject()} />
    );
  }
}
